import { lazy } from "react";
import { Routes, Route } from "react-router-dom";

import RoleSwitch from "modules/swiftboard/components/RoleSwitch";
import NotFound from "modules/swiftboard/not-found/page";

// /swiftboard/live-projects — role-based page
const pages = {
  ADMIN:    lazy(() => import("./admin/page")),
  CLIENT:   lazy(() => import("./client/LiveProjects")),
  EMPLOYEE: lazy(() => import("./employee/LiveProjects")),
};

// /swiftboard/live-projects/project-assignment/:projectId — admin only
const projectAssignmentPages = {
  ADMIN: lazy(() => import("./admin/project-assignment/Page")),
};

export default function LiveProjects() {
  return (
    <Routes>
      <Route index element={<RoleSwitch pages={pages} />} />
      <Route
        path="project-assignment/:projectId"
        element={<RoleSwitch pages={projectAssignmentPages} fallback={NotFound} />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
